module.exports = __webpack_public_path__ + "media/assets/images/payments/paypal-9c1bf67438e0d97b29968e0984c2f74e.png";